@if (data(); as detail) {
  <section class="flux-detail" data-testid="chat-flux-detail">
    <header class="flux-detail__header">
      <h3 class="flux-detail__title text-neutrals-text-default">{{ detail.title }}</h3>
      @if (detail.status) {
        <palantir-tag [color]="statusColor()" size="xs">{{ detail.status }}</palantir-tag>
      }
    </header>

    @if (detail.narrative) {
      <p class="flux-detail__narrative text-neutrals-text-secondary">{{ detail.narrative }}</p>
    }

    @if (entries().length) {
      <palantir-key-value-list
        class="flux-detail__fields"
        align="left"
        density="compact"
        [entries]="entries()"
      />
    }
  </section>
} @else {
  <p
    class="flux-detail__fallback text-neutrals-text-default"
    data-testid="chat-flux-detail-fallback"
  >
    {{ component().fallbackText }}
  </p>
}
